module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": ""
    },
    on: {
      "select": _vm.handleSelect,
      "change": _vm.ipChange
    },
    model: {
      value: (_vm.vl),
      callback: function($$v) {
        _vm.vl = $$v
      },
      expression: "vl"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-058624af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/TernoAutoCtrl.vue
// module id = 957
// module chunks = 0